<div class="info-display">
  <div class="text text_label">{{textLabel}}</div>
  <div class="text text_value" [ngClass]="getMark">{{textValue}}</div>
</div>
